type Props =  {
  width?: number;
  height?: number;
}

export default function AwardIcon({ width = 20, height = 20 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 21"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="currentColor" d="M14.1673 13.2045V18.9308C14.1673 19.1609 13.9807 19.3475 13.7507 19.3475C13.6752 19.3475 13.6011 19.327 13.5363 19.2881L10.0007 17.1667L6.46503 19.2881C6.2677 19.4065 6.01176 19.3425 5.89336 19.1452C5.85451 19.0804 5.83398 19.0063 5.83398 18.9308V13.2045C4.30988 11.9828 3.33398 10.1054 3.33398 8.00004C3.33398 4.31814 6.31875 1.33337 10.0007 1.33337C13.6826 1.33337 16.6673 4.31814 16.6673 8.00004C16.6673 10.1054 15.6914 11.9828 14.1673 13.2045ZM7.50065 14.1821V16.723L10.0007 15.223L12.5007 16.723V14.1821C11.7287 14.4946 10.8847 14.6667 10.0007 14.6667C9.11657 14.6667 8.27268 14.4946 7.50065 14.1821ZM10.0007 13C12.7621 13 15.0007 10.7615 15.0007 8.00004C15.0007 5.23862 12.7621 3.00004 10.0007 3.00004C7.23923 3.00004 5.00065 5.23862 5.00065 8.00004C5.00065 10.7615 7.23923 13 10.0007 13Z" />
    </svg>
  )
}
